import { Component, Input } from "@angular/core";

@Component({
    selector: 'player-form-indicator',
    templateUrl: './player-form-indicator.component.html',
    styleUrls: ['./player-form-indicator.component.scss'],
})
export class PlayerFormIndicatorComponent {
    @Input() form: number;
}